<template>
	<div id="equipmentDetail"  v-loading="loading" >
		<div class="gttcard">
			<div class="gttcard-in">
				<p style="border-bottom: 1px solid #eee;padding-bottom: 20px;" >{{ $t("terminal.device_detail") }}</p>
				<el-row   class="gtbtop">
					<el-col :span="8" oooffset="$isAdminType() || $isProdType()?0:5">
						<div class="glineflex">
							<div class="left_label">
								<label  >状态：</label>
							</div>
							<div class="right_label">
								<el-select :size="$ctrlSize" v-model="select_form.status" clearable style="width: 100%;"
									:placeholder="$t('app_select')" @change="getDetail">
									<el-option v-for="(item,index) in status_list" :key="index" :label="item" :value="index">
									</el-option>
								</el-select>
							</div>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="glineflex">
							<div class="left_label" style="width: 150px;"  >
								<label style="width: 150px;" >时间：</label>
							</div>
							<div class="right_label" style="display: flex;align-items: center;">
								<el-date-picker :size="$ctrlSize" v-model="date_value_1" @change="rec_date" type="daterange" range-separator="~"
									start-placeholder="开始时间" end-placeholder="结束时间" />
							</div>
						</div>
					</el-col>
					<!-- <el-col :span="8">
						<div class="glineflex">
				
							<div class="left_label">
								<label>smid：</label>
							</div>
							<div class="right_label" style="display: flex;align-items: center;">
								<el-input style="min-width: 70%;" size="small" v-model="select_form.smid"
									@keyup.enter.native="getDetail" placeholder="smid">
								</el-input>
							</div>
						</div>
					</el-col> -->
				</el-row>
				<el-table ref="multipleTable" class="gtbtop" tooltip-effect="dark" :data="tableData"
				  style="width: 100%">
					<el-table-column prop="device_sn" :label="$t('terminal.device_sn')" width>
					</el-table-column>
					<el-table-column prop="device_sdk_version" label="设备软件skd版本" width="150"></el-table-column>
					<el-table-column prop="device_supplier_id" label="设备 supplier_id" width="150"></el-table-column>
					<el-table-column prop="uploadStatus" label="状态" width>
						<template slot-scope="scope">
							<span>{{ status_list[scope.row.uploadStatus] }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="device_sound" label="设备音量" width></el-table-column>
					<el-table-column prop="device_address" label="设备在线地址" width="150"></el-table-column>
					<el-table-column prop="device_province" label="设备所在省" width="150"></el-table-column>
					<el-table-column prop="device_city" label="设备所在城市" width="160"></el-table-column>
					<el-table-column prop="device_district" label="设备所在区" width="150"></el-table-column>
					<el-table-column prop="trade_channel" label="交易渠道" width></el-table-column>
					<el-table-column prop="smid" label="smid" width></el-table-column>
					<el-table-column prop="speech_id" label="播报记录唯一标识" width="150"></el-table-column>
					<el-table-column prop="speech_scene" label="播报场景类型" width="150"></el-table-column>
					<el-table-column prop="speech_time" label="语音播报时间" width="150">
						<template slot-scope="scope">
							<span>{{ dateFormats(scope.row.speech_time)  }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="speech_content" label="语音播报内容" width="150"></el-table-column>
					<el-table-column prop="speech_result" label="语音播报结果" width="150"></el-table-column>
					
					<!-- <el-table-column :label="$t('app_operation')" width="180">
						<template slot-scope="scope">
							<el-button type="text" @click="toDetail(scope.row)">上报记录</el-button>
							<label  class="opbline">|</label>
							<el-button :disabled="scope.row.status == 1 ? false : true" @click="delRow(scope.row)" type="text" class="opdcolor">
								解绑
							</el-button>
						</template>
					</el-table-column> -->
				</el-table>
				<Pages class="gpages" :cpage="page" :ctotal="total" :config="pconfig"></Pages>
			</div>
			
		</div>
		
	</div>
</template>


<style>
	.edmg16 {
		margin-top: 16px;
	}

	.edttcolor {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.85);
	}

	.eddtcolor {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.65);
	}
</style>


<script>
	import DetailCard from "@/components/DetailCard.vue";
	import DcardNott from "@/components/DcardNott.vue";
	import ReceiptRec from "@/components/PlayrcAndLog.vue";
	import Merchant from "@/components/Merchant.vue";
	import Model from "@/components/Model.vue";
	import dayjs from 'dayjs'
	import Pages from "@/components/Pages.vue";
	export default {
		data() {
			return {
				tableData:[],
				pconfig: "",
				select_form: {
				
				},
				status_list: ["上送异常 ", "上送成功", "失败"],
				date_value_1:[],
				
				
				model_type_list: [{
						id: 0,
						name: "KS8303",
						value: "KS8303",
					},
					{
						id: 1,
						name: "ZTMD711",
						value: "ZTMD711",
					},
					{
						id: 2,
						name: "ZTMD715",
						value: "ZTMD715",
					},
					{
						id: 3,
						name: "KS8303 Plus",
						value: "KS8303 Plus",
					}

				],
				isBindMc: false,
				prconfig: "",
				mconfig: "",
				loading: false,
				config: "",
				baseInfo: {},
				page: 1,
				total: 0,
				showDia: false,
				editModel: {},
				editMc: {},
				tform: {
					deviceid: "",
					devicename: "",
					productKey: "",
					model: "",
					merchant: ""
				},
				tformVal: {
					deviceid: "",
					devicename: "",
					productKey: "",
					merchant: "",
					model: "",
				},
				rules: {
					deviceid: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					devicename: [{
						required: true,
						message: this.$t("app_input"),
						trigger: "blur"
					}],
					productKey: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					model: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}],
					merchant: [{
						required: true,
						message: this.$t("app_select"),
						trigger: "blur"
					}]
				}
			};
		},
		components: {
			Pages,
			DetailCard,
			ReceiptRec,
			Merchant,
			Model,
			DcardNott
		},
		computed: {
		},
		methods: {
			formatSeconds(s) {
				var day = Math.floor(s / (24 * 3600)); // Math.floor()向下取整 
				var hour = Math.floor((s - day * 24 * 3600) / 3600);
				var minute = Math.floor((s - day * 24 * 3600 - hour * 3600) / 60);
				var second = s - day * 24 * 3600 - hour * 3600 - minute * 60;
				if (day > 0) {
					return day + this.$t("app_day") + hour + this.$t("app_hour") + minute + this.$t("app_minute") +
						second + this.$t("app_second");
				} else if (hour > 0) {
					return hour + this.$t("app_hour") + minute + this.$t("app_minute") + second + this.$t("app_second");
				} else if (minute > 0) {
					return minute + this.$t("app_minute") + second + this.$t("app_second");
				} else {
					return second + this.$t("app_second");
				}
			},
			setMcCard(data) {
				this.mconfig = {
					title: this.$t("merchant.store_name") + data.merchantName,
					rd1: [{
							tt: this.$t("merchant.merchant_id"),
							ct: data.merchantId
						},
						{
							tt: this.$t("terminal.app_contactPhone"),
							ct: data.merchantPhone
						},
						// {tt:'绑定设备数量', ct: data.deviceNum},
						{
							tt: this.$t("merchant.merchant_num"),
							ct: data.merchantNo
						},
						{
							tt: this.$t("merchant.merchant_can_num"),
							ct: data.channelNo
						}
					],
					rd2: [{
							tt: this.$t("merchant.merchant_name"),
							ct: data.contacts
						},
						// {tt:'渠道商', ct: data.agentName},
						{
							tt: this.$t("terminal.merchant_add_time"),
							ct: data.createTime
						},
						{
							tt: this.$t("terminal.sub_organization"),
							ct: data.subMerchant
						}
					],
					rd3: [{
							tt: this.$t("terminal.broad_num"),
							ct: data.logplayNum
						},
						{
							tt: "",
							ct: ""
						}
					],
					edit: ""
				};
			},
			// 时间
			rec_date() {
				if (this.date_value_1 !== null && this.date_value_1[0] !== null) {
					this.select_form.startTime = this.dateFormat(this.date_value_1[0]) + '00:00:00'
					this.select_form.endTime = this.dateFormat(this.date_value_1[1]) + '23:59:59'
				}else{
					this.select_form.startTime = ""
					this.select_form.endTime = ""
				}
				this.getDetail()
			},
			// 日期格式化
			 dateFormat(dateData) {
				var date = new Date(dateData)
				var y = date.getFullYear()
				var m = date.getMonth() + 1
				m = m < 10 ? '0' + m : m
				var d = date.getDate()
				d = d < 10 ? '0' + d : d
			
				var hh = date.getHours()
				hh = hh < 10 ? '0' + hh : hh
			
				var mm = date.getMinutes()
				mm = mm < 10 ? '0' + mm : mm
			
				var ss = date.getSeconds()
				ss = ss < 10 ? '0' + ss : ss
			
				const time = y + '-' + m + '-' + d + ' '
				return time
			},
			// 日期格式化
			 dateFormats(dateData) {
				var date = new Date(dateData)
				var y = date.getFullYear()
				var m = date.getMonth() + 1
				m = m < 10 ? '0' + m : m
				var d = date.getDate()
				d = d < 10 ? '0' + d : d
			
				var hh = date.getHours()
				hh = hh < 10 ? '0' + hh : hh
			
				var mm = date.getMinutes()
				mm = mm < 10 ? '0' + mm : mm
			
				var ss = date.getSeconds()
				ss = ss < 10 ? '0' + ss : ss
			
				const time = y + '-' + m + '-' + d + ' ' + hh +  ":" + mm + ":" + ss
				return time
			},
			getDetail() {
				this.loading = true;
				var deviceid = this.$route.query.deviceId;
				this.$agentlogpaylist({
				page: this.page,
				rows: this.$gRow,
				deviceId: deviceid,
				...this.select_form
				},
					res => {
						this.loading = false;
						if (res.status == 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message.error(res.message);
						}

					},
					""
				);
			},
			setCard(data) {
				this.config = {
					title: this.$t("terminal.device_name") + ": " + data.devicename,
					rd1: [{
							tt: this.$t("terminal.device_sn"),
							ct: data.deviceid
						},
						{
							tt: this.$t("terminal.device_model"),
							ct: data.model
						},
						{
							tt: this.$t("terminal.network_type"),
							ct: data.terminalVersion
						},
						{
							tt: this.$t("terminal.app_distributor"),
							ct: data.agentName
						}
					],
					rd2: [{
							tt: this.$t("terminal.device_model_2"),
							ct: data.productName
						},
						{
							tt: this.$t("terminal.device_ip_address"),
							ct: data.ipaddress
						},
						{
							tt: this.$t("terminal.bound_merchant"),
							ct: data.merchantname ? data.merchantname : this.$t("terminal.unbound_merchant")
						}
					],
					rd3: [{
							tt: this.$t("terminal.cumulative_broadcast"),
							ct: data.totalOrder
						},
						// {tt: '累计收款', ct: data.totalPrice} 累计播报数量
						{
							tt: "",
							ct: ""
						}
					],
					testplay: () => {
						var deviceid = this.$route.query.deviceid;
						this.loading = true;
						this.$equipTestPlay(
							deviceid,
							data.productkey,
							res => {
								this.loading = false;
								if (res.errcode == 0) {
									this.$message.success(res.errmsg);
								} else {
									this.$message.error(res.errmsg);
								}
							},
							() => {
								this.loading = false;
							}
						);
					},
					edit: this.isEdit
				};
			},
			setBaseInfo(data) {
				this.baseInfo.createTime = data.createTime;
				this.baseInfo.activateTime = data.activateTime;
				this.baseInfo.lastOnlineTime = data.lastOnlineTime;
				this.baseInfo.lastOfflineTime = data.lastOfflineTime;
				this.baseInfo.volume = data.volume;
				this.baseInfo.hwVer = data.hwVer;
				this.baseInfo.appVer = data.appVer;
				this.baseInfo.sysAudioVer = data.sysAudioVer;
				this.baseInfo.usrAudioVer = data.usrAudioVer;
			},
			closeDia() {
				this.showDia = false;
				this.tform.deviceid = "";
				this.tform.productKey = "";
				this.tform.devicename = "";
				this.tform.merchant = "";
				this.tform.model = "";
			},
			setProCtr(vl) {
				var _this = this;
				this.editModel = {
					size: "middle",
					isbatch: false,
					value: vl ? vl : "",
					callback: vl => {
						_this.tform.productKey = vl;
					}
				};
			},
			setMcCtr(vl) {
				var _this = this;
				this.editMc = {
					// type:'0',
					size: "",
					vlkey: "clientKey",
					value: vl ? vl : "",
					callback: vl => {
						_this.tform.merchant = vl;
					}
				};
			}
		},
		mounted() {
			this.getDetail();
		}
	};
</script>